import React, { useEffect, useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { FadeIn } from '../components/FadeIn';
import { useModals } from '../contexts/ModalContext';
import { CheckCircleIcon, HeartIcon, ShieldCheckIcon, PlayIcon, StarIcon, MapPinIcon, VideoIcon } from 'lucide-react';
const MOCK_COMPANIONS = [{
  id: 1,
  name: 'Mary J.',
  location: 'Raleigh, NC',
  rate: '$24/hr',
  rating: 4.9,
  reviews: 41,
  bio: 'Retired nurse with 10+ years of experience in senior care. Specializes in dementia support and mobility assistance.',
  image: 'https://images.unsplash.com/photo-1581056771107-24ca5f033842?w=400&auto=format&fit=crop',
  badges: ['Dementia Support', 'RN Background']
}, {
  id: 2,
  name: 'David L.',
  location: 'Durham, NC',
  rate: '$20/hr',
  rating: 5.0,
  reviews: 28,
  bio: 'Compassionate companion focused on active aging. Great at meal prep, light housekeeping, and transportation to appointments.',
  image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&auto=format&fit=crop',
  badges: ['Transportation', 'Meal Prep']
}, {
  id: 3,
  name: 'Susan W.',
  location: 'Chapel Hill, NC',
  rate: '$22/hr',
  rating: 4.8,
  reviews: 35,
  bio: 'Patient and attentive caregiver. Loves playing board games, reading, and ensuring a safe, comfortable home environment.',
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&auto=format&fit=crop',
  badges: ['Part-Time', 'Overnight']
}];
export function CompanionCare() {
  const {
    openModal
  } = useModals();
  const [activeFilter, setActiveFilter] = useState('All');
  useEffect(() => {
    document.title = "Vetted Senior Companions & Caregivers | Care Nomad";
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1023" data-mp="3gfmh0e3docbu">
      <Navbar data-id="element-1024" data-mp="hqduf9drzh7d" />
      
      <main className="flex-1" data-id="element-1025" data-mp="hqxaekjv7vir">
        {/* High-Intent PPC Hero Section */}
        <section className="w-full relative py-16 lg:py-24 flex items-center justify-center min-h-[60vh]" data-id="element-1026" data-mp="d076zcv022qp">
          <div className="absolute inset-0 z-0" data-id="element-1027" data-mp="2779ez4q9dwz3">
            <img src="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=1600&auto=format&fit=crop" alt="Senior Companion Care Background" className="w-full h-full object-cover" data-id="element-1028" data-mp="278kqjqpy490r" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/95 to-[#1a2332]/70" data-id="element-1029" data-mp="1xhgbkr09so5x"></div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-1030" data-mp="22ezui47wxp47">
            <div className="max-w-3xl" data-id="element-1031" data-mp="1og05uwkeha81">
              <FadeIn direction="up" data-id="element-1032" data-mp="1sjejjgkv9eib">
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-1033" data-mp="1skg7umqw7xhz">
                  Trusted, Vetted Senior Companions—Backed by <span className="text-[#007a87]" data-id="element-1034" data-mp="1jhf24n5xw8eu">AI Check-Ins</span>
                </h1>
                <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed font-medium" data-id="element-1035" data-mp="38wmxm8fx2ksh">
                  Connect with compassionate, background-checked senior companions across NC, VA, MD, and DC. Monitor daily routines, meals, and medication reminders with live photo and micro-video activity feeds.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-1036" data-mp="xb46edeh2sub">
                  <button onClick={() => openModal('talent')} className="bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-4 px-8 rounded-xl transition-colors text-lg shadow-lg flex items-center justify-center gap-2" data-id="element-1037" data-mp="1byxoc4r167g2">
                    Find a Companion in 2 Minutes
                  </button>
                  <a href="#check-ins" className="bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-bold py-4 px-8 rounded-xl transition-colors text-lg border border-white/30 flex items-center justify-center gap-2" data-id="element-1038" data-mp="1g12gez1tyw0l">
                    <PlayIcon className="w-5 h-5" data-id="element-1039" data-mp="1pz03vkbv8os5" />
                    See How Video Check-Ins Work
                  </a>
                </div>
                
                <div className="flex flex-wrap gap-4 text-sm font-medium text-white/80" data-id="element-1040" data-mp="3rqd4hx6swaie">
                  <span className="flex items-center gap-1.5" data-id="element-1041" data-mp="2it579lqvak1a"><ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-1042" data-mp="2is3nmsvscp7y" /> 100% Background Checked</span>
                  <span className="flex items-center gap-1.5" data-id="element-1043" data-mp="2nqetksiymfkw"><HeartIcon className="w-4 h-4 text-green-400" data-id="element-1044" data-mp="2sr2uc5wzqasb" /> Dementia Care Trained Options</span>
                  <span className="flex items-center gap-1.5" data-id="element-1045" data-mp="2wsedbslczxrj"><CheckCircleIcon className="w-4 h-4 text-green-400" data-id="element-1046" data-mp="2wrd31qc63fav" /> Zero Search Fees Until You Hire</span>
                  <span className="flex items-center gap-1.5" data-id="element-1047" data-mp="203ynrwi91oef"><StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-1048" data-mp="2518kzybvr4ct" /> 4.9/5 Star Family Rating</span>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* Interactive Profile Grid */}
        <section className="py-20 bg-gray-50" data-id="element-1049" data-mp="2dvd6014c1lkf">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1050" data-mp="1hbw56fm1ry1j">
            <div className="flex flex-col md:flex-row justify-between items-end mb-10 gap-6" data-id="element-1051" data-mp="1hbnr4ke6umor">
              <div data-id="element-1052" data-mp="1lbofawr3ac90">
                <h2 className="text-3xl font-bold text-[#1a2332] mb-3" data-id="element-1053" data-mp="1lb4vfahvpdsc">Top-Rated Companions Near You</h2>
                <p className="text-[#5a6a7a]" data-id="element-1054" data-mp="18uvq3z68lspw">Browse pre-screened professionals ready to interview today.</p>
              </div>
              <div className="flex gap-2 overflow-x-auto pb-2 w-full md:w-auto hide-scrollbar" data-id="element-1055" data-mp="14simbgb1w4vr">
                {['All', 'Full-Time', 'Part-Time', 'Dementia Support', 'Overnight'].map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${activeFilter === filter ? 'bg-[#1a2332] text-white' : 'bg-white text-[#5a6a7a] border border-gray-200 hover:border-[#1a2332]'}`} data-id="element-1056" data-mp="uvdxf8ptlvb9">
                    {filter}
                  </button>)}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1057" data-mp="7503fcnodme1">
              {MOCK_COMPANIONS.map((companion, idx) => <FadeIn key={companion.id} direction="up" delay={idx * 0.1} data-id="element-1058" data-mp="3tlqqr5oda3f9" data-mpi={idx}>
                  <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group" data-id="element-1059" data-mp="2i1y1be2nm77">
                    <div className="relative h-64 overflow-hidden" data-id="element-1060" data-mp="3oo8qe3of0wiv">
                      <img src={companion.image} alt={companion.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-1061" data-mp="3ooh0xox2fpqw" />
                      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-[#1a2332] shadow-sm" data-id="element-1062" data-mp="l6gpfzsax28j">
                        {companion.rate}
                      </div>
                      <div className="absolute bottom-4 left-4 flex gap-2" data-id="element-1063" data-mp="bfvuqnfr0huw">
                        {companion.badges.map(badge => <span key={badge} className="bg-[#1a2332]/80 backdrop-blur-md text-white text-xs font-bold px-2.5 py-1 rounded-md" data-id="element-1064" data-mp="13xzsg6mbsgak">
                            {badge}
                          </span>)}
                      </div>
                    </div>
                    <div className="p-6" data-id="element-1065" data-mp="2jnhffzqf46bs">
                      <div className="flex justify-between items-start mb-3" data-id="element-1066" data-mp="2yd6la89ggyie">
                        <div data-id="element-1067" data-mp="2telko7qakctf">
                          <h3 className="text-xl font-bold text-[#1a2332] flex items-center gap-2" data-id="element-1068" data-mp="2tgg75qh7oczm">
                            {companion.name}
                            <ShieldCheckIcon className="w-5 h-5 text-blue-500" data-id="element-1069" data-mp="20qfyrhni4hs0" />
                          </h3>
                          <p className="text-[#5a6a7a] text-sm flex items-center gap-1 mt-1" data-id="element-1070" data-mp="2epz7abk85v4u">
                            <MapPinIcon className="w-4 h-4" data-id="element-1071" data-mp="2aongi2pm73v2" /> {companion.location}
                          </p>
                        </div>
                        <div className="flex items-center gap-1 bg-yellow-50 text-yellow-700 px-2 py-1 rounded-lg text-sm font-bold" data-id="element-1072" data-mp="3q42yxb3cb76q">
                          <StarIcon className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-1073" data-mp="3m5vh0cx53zty" />
                          {companion.rating}
                        </div>
                      </div>
                      <p className="text-[#5a6a7a] text-sm leading-relaxed mb-6 line-clamp-2" data-id="element-1074" data-mp="1ogi1ej2iy48k">
                        {companion.bio}
                      </p>
                      <button onClick={() => openModal('talent')} className="w-full bg-gray-50 hover:bg-[#5a55ea] text-[#1a2332] hover:text-white border border-gray-200 hover:border-[#5a55ea] font-bold py-3 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-1075" data-mp="1y7368o8sk4zx">
                        <VideoIcon className="w-5 h-5" data-id="element-1076" data-mp="2c62l546i55iw" />
                        Book 1-Click Video Interview
                      </button>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* Feature Deep Dive */}
        <section id="check-ins" className="py-20 bg-white" data-id="element-1077" data-mp="mq33szsqc9s6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1078" data-mp="mspkpq1ig1n2">
            <div className="text-center mb-16" data-id="element-1079" data-mp="302pdn9nxebhe">
              <h2 className="text-3xl lg:text-4xl font-bold text-[#1a2332] mb-4" data-id="element-1080" data-mp="2vao5nzxsj6x6">Why Families Choose CareNomad</h2>
              <p className="text-[#5a6a7a] text-lg max-w-2xl mx-auto" data-id="element-1081" data-mp="2r8awt2nqysw6">Traditional listing sites leave you in the dark. We built a platform for modern accountability and peace of mind.</p>
            </div>

            <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-1082" data-mp="3j0a58oi2ro5p">
              <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-200 p-6 font-bold text-[#1a2332]" data-id="element-1083" data-mp="3ezq4zc27g4fc">
                <div className="col-span-1" data-id="element-1084" data-mp="39xhaucdliwbn">Feature</div>
                <div className="text-center text-[#007a87]" data-id="element-1085" data-mp="350qz218tqmw1">CareNomad</div>
                <div className="text-center text-gray-400" data-id="element-1086" data-mp="1yk5fyqztdo1m">Traditional Sites</div>
              </div>
              {[{
              name: 'AI Video Check-Ins',
              us: true,
              them: false
            }, {
              name: 'Automated Geofencing (EVV)',
              us: true,
              them: false
            }, {
              name: '1-Click Video Interviews',
              us: true,
              them: false
            }, {
              name: 'Free Messaging & Search',
              us: true,
              them: false
            }, {
              name: 'Background Checks Included',
              us: true,
              them: 'Extra Fee'
            }].map((row, i) => <div key={i} className="grid grid-cols-3 p-6 border-b border-gray-100 last:border-0 items-center" data-id="element-1087" data-mp="3v46zx1q0jszm" data-mpi={i}>
                  <div className="col-span-1 font-medium text-[#1a2332]" data-id="element-1088" data-mp="cpo3gzncj74y">{row.name}</div>
                  <div className="text-center flex justify-center" data-id="element-1089" data-mp="7rctmox1wwmq">
                    <CheckCircleIcon className="w-6 h-6 text-green-500" data-id="element-1090" data-mp="mpyf4ftqg6i0" />
                  </div>
                  <div className="text-center flex justify-center text-[#5a6a7a] font-medium" data-id="element-1091" data-mp="hpslwv7tebxt">
                    {row.them === false ? <div className="w-4 h-0.5 bg-gray-300 rounded-full" data-id="element-1092" data-mp="2ohtdxuuw4git"></div> : row.them}
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Frictionless Lead Capture */}
        <section className="py-20 bg-[#007a87]" data-id="element-1093" data-mp="z1r2v88r34cx">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1094" data-mp="13z0qcickx5y4">
            <FadeIn direction="up" data-id="element-1095" data-mp="pa4hij2p7owg">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" data-id="element-1096" data-mp="p91vopk8gcne">Ready to find the perfect companion?</h2>
              <p className="text-white/90 text-lg mb-10" data-id="element-1097" data-mp="u73ed9dqy9yc">Tell us what you need, and we'll send you the top 3 vetted profiles in your area.</p>
              <button onClick={() => openModal('talent')} className="bg-white text-[#007a87] hover:bg-gray-50 font-bold py-4 px-10 rounded-xl transition-colors text-lg shadow-xl" data-id="element-1098" data-mp="kai9qp5n30v1">
                Start Free Search
              </button>
            </FadeIn>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-gray-50" data-id="element-1099" data-mp="20oi13bqf5i6o">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1100" data-mp="20pt4vbjv6pxs">
            <h2 className="text-3xl font-bold text-[#1a2332] mb-10 text-center" data-id="element-1101" data-mp="25n1shrns7m6f">Frequently Asked Questions</h2>
            <div className="space-y-4" data-id="element-1102" data-mp="247pdh944xbms">
              {[{
              q: 'How does the background check process work?',
              a: 'Every companion undergoes a comprehensive multi-state criminal background check, sex offender registry search, and identity verification before their profile goes live.'
            }, {
              q: 'Are there any upfront fees?',
              a: 'No. You can search, message, and interview candidates for free. You only pay a transparent placement fee when you officially hire a companion through our platform.'
            }, {
              q: 'How do CareNomad Check-Ins™ work for senior care?',
              a: 'Our proprietary app uses geofencing to verify when a companion arrives. Throughout the day, it prompts them to upload quick photos or 5-second videos of meals, medication reminders, and activities directly to your family dashboard.'
            }, {
              q: 'Do you help with caregiver taxes (W-2 vs 1099)?',
              a: 'Yes! Our platform provides automated timesheets and integrates with leading household payroll providers to make tax compliance seamless.'
            }].map((faq, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-1103" data-mp="3d87efeju4dxc" data-mpi={i}>
                  <h4 className="font-bold text-[#1a2332] text-lg mb-2" data-id="element-1104" data-mp="3i5r6bh9ggp7r">{faq.q}</h4>
                  <p className="text-[#5a6a7a] leading-relaxed" data-id="element-1105" data-mp="3n5vkh0mw57ut">{faq.a}</p>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-1106" data-mp="nxblgdbt22" />
    </div>;
}